// extracted by mini-css-extract-plugin
module.exports = {"cta":"CTA-newsletter-exit-styles-module--cta--cwtJa","button":"CTA-newsletter-exit-styles-module--button--3I_IR"};